<app-form-schema-renderer *ngIf="resolvedSchema && data"
						[property]="[]" [schema]="resolvedSchema" [readonly]="isReadonly$ | async" [data]="data"
						(emitFormSubmit)="editProject($event)" [formID]="projectFormID"
						(emitFormValid)="setSubmitActive($event)">
</app-form-schema-renderer>
<div class="toolbar">
	<app-splitbutton class="cancel-button" [elements]="[projectCancelSplitButton]"></app-splitbutton>
	<nz-upload *appIfPermission="'project-archive:write'"
			[nzAccept]="'application/zip'"
			[nzCustomRequest]="zipRequest"
			[nzFileList]="fileList"
			(touchend)="uploadButtonTouchEnd($event)"
	>
		<app-splitbutton [elements]="[projectArchiveUploadSplitButton]"></app-splitbutton>
	</nz-upload>
	<ng-container *appIfPermission="'projects:write'">
		<app-splitbutton *ngIf="resolvedSchema && data"
						[elements]="[projectEditSplitButton]">
		</app-splitbutton>
	</ng-container>
</div>
